import { Button, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import { deleteRequest, get, postMultipart } from '../../Common/api'
import { Color } from '../../Common/Color'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'
import ProcedureForm from '../ProcedurePage/ProcedureForm'
import ProceduresList from './ProceduresList'
import ProceduresFilters from './ProceduresFilters'

export default function ProceduresPage () {
  const [procedures, setProcedures] = useState([])
  const [actors, setActors] = useState([])
  const [filteredProcedures, setFilteredProcedures] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getProcedures()
  }, [])

  const getProcedures = async () => {
    setLoading(true)
    await get({
      url: 'admin/procedures',
      params: {},
      onSuccess: (res) => {
        setProcedures(res.procedures)
        setFilteredProcedures(res.procedures)
        setActors(res.actors.sort().map((actor) => ({ value: actor, label: actor })))
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const openFormModal = (procedure) => {
    form.resetFields()
    if (procedure) {
      form.setFieldsValue(procedure)
    }
    setModalVisible(true)
  }

  const addRequest = async (values) => {
    setLoading(true)
    await postMultipart({
      url: 'admin/procedures',
      params: values,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: (res) => {
        setProcedures([...procedures, res])
        setFilteredProcedures([...filteredProcedures, res])
        setLoading(false)
        setModalVisible(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const deleteProcedure = async (procedure) => {
    await deleteRequest({
      url: `admin/procedures/${procedure.id}`,
      params: {},
      notification: { api: notificationApi, state: 'delete' },
      onSuccess: (res) => {
        setProcedures(procedures.filter(i => i.id !== res.id))
        setFilteredProcedures(filteredProcedures.filter(i => i.id !== res.id))
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  return (
    <Layout>
      <Spin spinning={!procedures}>
        { filteredProcedures && <>
          <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '20px' }}><b>{procedures.length}</b> {t('Admin.Procedure.proceduresPage.title')}</div>
              <ProceduresFilters procedures={procedures} setFilteredProcedures={setFilteredProcedures} actors={actors} />
              <Button onClick={openFormModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
            </div>
          </Layout>
          <ProceduresList procedures={filteredProcedures} deleteProcedure={deleteProcedure} />
          <CustModal
            open={modalVisible}
            setOpen={setModalVisible}
            width="1000px"
            title={t('Admin.Procedure.proceduresPage.addModalTitle')}
            onOk={form.submit}
            confirmLoading={loading}
          >
            <Spin spinning={loading}>
              <ProcedureForm form={form} onFinish={addRequest} actors={actors} />
            </Spin>
          </CustModal>
        </>}
      </Spin>
    </Layout>
  )
}
